import { Component, OnInit, Input, ChangeDetectionStrategy, OnChanges, SimpleChanges } from '@angular/core';
import { BaseButton } from './baseButton';

@Component({
  selector: 'app-button',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<button type="button" [class]="buttonClass + ' ' + guestClass"  (click)="onClick($event)" [title]="title"
  [disabled]="disabled" [attr.aria-disabled]="ariaDisabled">
   <ng-container *ngIf="!hideText">{{text}}</ng-container>
   <ng-container *ngIf="!hideText && icon || working">&nbsp;</ng-container>
   <app-spinner size="s" *ngIf="working"></app-spinner>
   <span *ngIf="icon && !working" [class]="iconClass" aria-hidden="true"></span>
</button>`
})
export class ButtonComponent extends BaseButton implements OnInit, OnChanges {

  @Input() hideText = false;

  @Input() guestClass: string = '';

  ngOnInit() {
    super.onInit();
  }

  get ariaDisabled(): string {
    return this.disabled || this.working ? 'true' : 'false';
  }

  get title(): string {
    return this.hideText ? this.text : '';
  }

  ngOnChanges(changes: SimpleChanges) {
    super.onChanges();
  }

}
